
import { useResourceUsage } from './use-resource-usage';
import { useSubscriptionData } from './use-subscription-data';
import { useAuth } from '@/contexts/AuthContext';

export const useCTraderProfileValidation = () => {
  const { user } = useAuth();
  const { data: subscriptionData } = useSubscriptionData(user?.id);
  const { data: resourceUsage } = useResourceUsage(user?.id);

  const canCreateProfile = () => {
    if (!subscriptionData?.package || !resourceUsage) {
      return false;
    }

    return resourceUsage.cspAccountsCount < subscriptionData.package.max_csp_accounts;
  };

  const getErrorMessage = () => {
    if (!subscriptionData?.package) {
      return 'No active subscription found. Please upgrade to create cTrader profiles.';
    }

    if (resourceUsage && resourceUsage.cspAccountsCount >= subscriptionData.package.max_csp_accounts) {
      return `You've reached your limit of ${subscriptionData.package.max_csp_accounts} cTrader profiles. Please upgrade your subscription to add more profiles.`;
    }

    return null;
  };

  return {
    canCreateProfile,
    getErrorMessage,
    currentCount: resourceUsage?.cspAccountsCount || 0,
    maxProfiles: subscriptionData?.package?.max_csp_accounts || 0
  };
};
